import React, { useContext, useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles';
import { Container, Grid, FormControl, TextField, Typography } from '@material-ui/core'
import { PageContext } from '../Context/PageProvider'
import moment from 'moment'
import { TicketRateIcon } from '../Pages/TicketRates'
import { COLORS } from '../Stylesheet/theme'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'

const DATE_PICKER_FORMAT = 'yyyy-MM-DD'
function RateTicketsHeader({ t, onChangeDate, rateAvg }) {
    const classes = useStyles()
    const today = moment().format(DATE_PICKER_FORMAT)
    const lastYear = moment().subtract(1, 'year').format(DATE_PICKER_FORMAT)
    const [selectedFromDate, setSelectedFromDate] = useState({ to: moment().toISOString(), from: moment().subtract(1, 'year').toISOString() })

    useEffect(() => {
        onChangeDate(selectedFromDate)
    }, [selectedFromDate])


    return (
        <Container className={classes.root} maxWidth="xl">
            <Container maxWidth="md">
                <Grid container>
                    <Grid item xs={5}>
                        <FormControl className={classes.formControl}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    id="from-date"
                                    label={t('from')}
                                    format="dd.MM.yyyy"
                                    className={classes.datePicker}
                                    defaultValue={lastYear}
                                    value={selectedFromDate.from}
                                    onChange={(value) => value && setSelectedFromDate(prevState => ({ ...prevState, from: moment(value).toISOString() }))}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />

                                <KeyboardDatePicker
                                    id="to-date"
                                    label={t('to')}
                                    format="dd.MM.yyyy"
                                    className={classes.datePicker}
                                    value={today}
                                    value={selectedFromDate.to}
                                    onChange={(value) => value && setSelectedFromDate(prevState => ({ ...prevState, to: moment(value).toISOString() }))}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </FormControl>
                    </Grid>
                    <Grid container xs={7} alignItems="center">
                        <FormControl className={[classes.formControl, classes.avgRateContainer]}>
                            {rateAvg && <Typography variant="h3">{`${rateAvg}.0`}</Typography>}
                            {TicketRateIcon(rateAvg)}
                        </FormControl>
                    </Grid>
                </Grid>
            </Container>
        </Container>
    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.primary.canvas
    },
    formControl: {
        flexDirection: 'row',
        paddingRight: theme.padding.small,
        marginTop: theme.margin.small,
        marginBottom: theme.margin.small,
        minWidth: 120,
    },
    avgRateContainer: {
        justifyContent: 'flex-end',
        alignItems: 'center',
        '& h3': {
            color: COLORS.PRIMARY,
            marginRight: theme.margin.small
        }
    },
    datePicker: {
        marginRight: theme.margin.small
    }
}))

export default withTranslation()(withRouter(RateTicketsHeader))